._container_1dxhv_1 {
  padding-top: 0;
  padding-bottom: 0; }
